import { IGalaxy, IMessage, Series } from '@/galaxy-cruise/api_interface'
import { store } from '@/store'
import { EquatorialCoord } from '@hscmap/angle'
import { Route } from 'vue-router'
import { api } from '../api'
import { ISession } from "../api_interface"
import { UNAUTHORIZED } from 'http-status-codes'
import * as easing from '@hscmap/easing'
import { i18nTranslate } from "@/i18n"

export function coordFromGalaxy(g: IGalaxy) {
  const { ra, dec } = g
  return EquatorialCoord.fromDeg(ra, dec)
}

export async function reloadSession() {
  const series = store.galaxyCruise.series
  const res = await api.default('../api/v1/session', { params: { series } })
  const session: ISession = res.data
  loadSession(session)
}

export async function reloadMessages(update = false) {
  const res = await api.default.post('../api/v1/messages/all', { update })
  store.galaxyCruise.all_messages = res.data.messages
  return { messages: res.data.messages as IMessage[], last: res.data.last as string, now: res.data.now as string }
}

export async function loginGuard(to: Route, from: Route, next: (path: string | void) => void) {
  try {
    const series = store.galaxyCruise.series
    const res = await api.passErrors(UNAUTHORIZED).get<ISession>('../api/v1/session', { params: { series } })
    // ログインしていないと↑で例外
    const session: ISession = res.data
    loadSession(session)
    const next2 = (path: string) => {
      return next(to.path !== path ? path : undefined)
    }
    if (!session.user.password_is_set) {
      return next2('/new_password')
    }
    if (!registrationCompleted(session)) {
      return next2('/welcome')
    }
    next()
  } catch {
    next(`/login?next=${encodeURI(to.fullPath)}`)
  }
}

function registrationCompleted(session: ISession) {
  return session.user.nickname !== null
}

function loadSession(session: ISession) {
  const gc = store.galaxyCruise
  Object.freeze(session.extra_tracts) // for performance
  Object.freeze(session.levels) // for performance
  gc.session = session
  gc.series = session.series_name
  store.locale = session.user.locale
}

export async function goNextGalaxy(duration = 2000) {
  const gc = store.galaxyCruise
  const next = gc.nextQuestion
  if (next) {
    const globe = store.currentGlobe()
    const { ra, dec } = next
    await globe.viewFactory.jumpTo(
      { fovy: 0.0005 },
      {
        coord: EquatorialCoord.fromDeg(ra, dec),
        easingFunction: easing.slowStartStop4,
        duration,
      })
    gc.targetGalaxy = next
  } else {
    alert(message_completed_course())
  }
}

function message_completed_course() {
  const dict = {
    en: 'You have completed the Practice Course.',
    ja: 'このコースは既に完了しています。',
  }
  return i18nTranslate(dict)
}
